module.exports = __webpack_public_path__ + "static/Frogsong4-745c485f740d09603b4916b69a2cdf21.webp";